import React, { useEffect, useState } from "react";
import {
  Dialog,
  Box,
  Typography,
  Button,
  CircularProgress,
  DialogContent,
  DialogTitle,
  Stack,
  Avatar,
  IconButton,
} from "@mui/material";
import { _workspace_project_working_on_tasks_list } from "src/DAL/team";
import { useSnackbar } from "notistack";
import { Scrollbar, Iconify } from "src/components";
import { useNavigate } from "react-router-dom";
import { noTasks } from "src/assets";
import DashboardTaskCard from "src/pages/dashboard/components/DaashboardTaskCard";
import { s3baseUrl } from "src/config";

export default function ProjectTeamTaskDialog({
  open,
  onClose,
  title,
  image,
  project_id,
  workspace_id,
}) {
  const [userTasks, setUserTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  // ---------------------------------------------------------------
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  // ------------------TEAM Working on Tasks------------------------
  const getProjectStartedTasksList = async () => {
    setLoading(true);

    const req_data = {};

    if (project_id) {
      // send only project_id
      req_data.project_id = project_id;
    } else {
      // send only workspace_id
      if (workspace_id) {
        req_data.workspace_id = workspace_id;
      }
    }

    const result = await _workspace_project_working_on_tasks_list(req_data);
    if (result.code === 200) {
      console.log(result.data, "result.data");
      setUserTasks(result.data);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setLoading(false);
  };

  const handleNavigate = (task) => {
    const { section_id, _id } = task;
    const project_id = task?.project?.id;
    navigate(
      `/workspaces/copied-task-link/${project_id}/${section_id}/${_id}`,
      { state: { task_id: _id } }
    );
  };

  useEffect(() => {
    if (open) {
      getProjectStartedTasksList();
    }
  }, [open]);

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: { xs: "8px 14px !important", md: "16px 24px !important" },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {image && (
            <Avatar
              sx={{ width: 34, height: 34 }}
              src={s3baseUrl + image}
              alt={title}
            />
          )}
          <Typography variant="h6">
            {title ? title : "Team Started Tasks"}
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="medium">
          <Iconify icon="mingcute:close-line" />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          padding: "8px !important",
          minHeight: "70vh",
          maxHeight: "70vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexGrow: 1,
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Scrollbar sx={{ maxHeight: "70vh", flexGrow: 1 }}>
            <div
            className="d-flex align-items-center gap-2"
              style={{
                margin: "0px 16px 6px 16px",
                fontSize: "12px",
                color: "#637381",
              
              }}
            >
              <Iconify icon="bi:people-fill" fontSize="16px" /> Team members in this project are currently working on these
              tasks.
            </div>
            {userTasks.length > 0 ? (
              <Stack spacing={1} sx={{ padding: "4px 16px" }}>
                {userTasks.map((task, index) => (
                  <DashboardTaskCard
                    key={index}
                    task={task?.task_detail}
                    isWorking={true}
                    multipleWorking={true}
                  />
                ))}
              </Stack>
            ) : (
              /* No Task --------------------- */
              <Box
                sx={{
                  height: "100%",
                  minHeight: "60vh",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <Box
                  sx={{
                    width: "160px",
                    mb: 2,
                  }}
                >
                  <img width="100%" src={noTasks} alt="No Tasks" />
                </Box>

                <Typography
                  color={(theme) => theme.palette.text.disabled}
                  variant="body2"
                  fontWeight="bold"
                >
                  Not Found!
                </Typography>

                <Typography
                  color={(theme) => theme.palette.text.disabled}
                  variant="body2"
                >
                  There are no started tasks
                </Typography>
              </Box>
            )}
          </Scrollbar>
        )}
      </DialogContent>
    </Dialog>
  );
}
